import { APIClient } from "../helpers/api_helper";

import * as url from "../helpers/url_helper";

const api = new APIClient();

// List internal users with thread preview (last message + unread count)
export const getDirectContacts = () => api.get(`${url.DIRECT_MESSAGE}/contacts`, {});

// Full 1:1 history with another user (marks incoming as read)
export const getDirectConversation = (otherUserId: string) =>
  api.get(`${url.DIRECT_MESSAGE}/${otherUserId}`, {});

// Send a direct message
export const sendDirectMessage = (payload: { recipientId: string; content: string }) =>
  api.create(url.DIRECT_MESSAGE, payload);
